module.exports = __webpack_public_path__ + "img/pointlight_thumb.fc8c6cb0.jpg";